import ImageWithText from '../ImageWithText';
import back from '../../../../images/imagen_RESPIRE.png';
import HeroContainer from '../HeroContainer';
import arrowDown from '@plone/volto/icons/down.svg';
import { Icon } from '@plone/volto/components';
import { Container, Link } from '@plone/components';
import '@plone/components/dist/basic.css';

const View = (props) => {
  return (
    <Container>
      <HeroContainer>
        <ImageWithText src={back} />
        <div className="text-hero-section">
          <h3 className="">
            Sistemas de emisiones atmosféricas en alta resolución para la
            modelización de la calidad del aire y la monitorización de gases de
            efecto invernadero en España
          </h3>
          {/* <Link href='#first-section' className="heading-wrapper">
              <Icon color='white' size='50' name={arrowDown} />
            </Link> */}
        </div>
      </HeroContainer>
    </Container>
  );
};

export default View;
